import React, { useCallback, useEffect, useState } from 'react'

const RadioGroupState = ({handleParams, params}) => {

	const getState = useCallback(()=>{
		return params.get('state')
	},[params])

	const [state, setState] = useState(params.get('state'));

	useEffect(()=>{
		const currentState = getState()
		if ( state !== currentState) {
			const newParams = new URLSearchParams(params.toString());
			
			newParams.set('state', state)
			if(state === null){
				newParams.delete('state')
			}
			handleParams(newParams)
		}
	},[state])

	useEffect( ()=> {
		const newState = params.get('state')
		if(state !== newState) {
			console.log({state, newState})
			setState(newState)
		}
	},[params])

	return (		
		<div className="btn-group">
			<input defaultChecked={ state === null } type="radio" name="state" id="alla" />
			<label 
				htmlFor="alla"
				className={state === null ? 'active': ''}
				onClick={()=>{
					setState(null)
				}}
				>Alla</label>
			<input defaultChecked={ state === 'Ny' } type="radio" name="state" id="ny" />
			<label 
				htmlFor="ny"
				className={state === 'Ny' ? 'active': ''}
				onClick={()=>{
					setState('Ny')
				}}
				>Nya</label>
			<input defaultChecked={ state === 'Begagnad' } type="radio" name="state" id="begagnad" />
			<label 
				htmlFor="begagnad"
				className={state === 'Begagnad' ? 'active': ''}
				onClick={()=>{
					setState('Begagnad')
				}}
				>Begagnade</label>
		</div>
	)
}

export default RadioGroupState